<div cdkDrag cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="dragPosition" (cdkDragEnded)="onDragEnd($event)">
  <h2 mat-dialog-title cdkDragHandle>{{title}}</h2>
<mat-dialog-content>
  <div class="tables-wrapper">
    <!-- Left Table -->
    <div class="table-section">
      <div class="table-title">Current Node’s Maps</div>
      <div class="table-container">
        <table mat-table [dataSource]="currentNodeMapdataSource" class="mat-elevation-z8">   
          <ng-container matColumnDef="Fields mapped">
            <th mat-header-cell *matHeaderCellDef>Fields Mapped</th>
            <td mat-cell *matCellDef="let element">
              <span [style.color]="element.color">{{element.fieldsmatchedmsg}}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="Last saved">
            <th mat-header-cell *matHeaderCellDef>Last Saved</th>
            <td mat-cell *matCellDef="let element">
              <span style="color: #ffffffb3;">{{element.lastModified}}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
              <button mat-button (click)="selectField(element.mappedId)">Select >></button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
    </div>

    <!-- Right Table -->
    <div class="table-section">
      <div class="table-title">All Maps</div>
      <div class="table-container">
        <table mat-table [dataSource]="allMapdataSource" class="mat-elevation-z8">
          <!-- same columns -->
        <ng-container matColumnDef="Fields mapped">
            <th mat-header-cell *matHeaderCellDef>Fields Mapped</th>
            <td mat-cell *matCellDef="let element">
              <span [style.color]="element.color">{{element.fieldsmatchedmsg}}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="Last saved">
            <th mat-header-cell *matHeaderCellDef>Last Saved</th>
            <td mat-cell *matCellDef="let element">
              <span style="color: #ffffffb3;">{{element.lastModified}}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
              <button mat-button (click)="selectField(element.mappedId)">Select >></button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button (click)="confirmMapping()" mat-button color="primary" mat-dialog-close>OK</button>
  <button (click)="cancel()" mat-button>Cancel</button>
</mat-dialog-actions>
</div>